const initialState = {};

export const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
